export default __webpack_public_path__ + "static/Corprate_HK_Internships_03-2c5e5681ae2ed5fdf8ddff6f3ae53812.jpg";